module.exports = __webpack_public_path__ + "static/media/freshservice-logo.9610a70c.svg";